module.exports = __webpack_public_path__ + "static/media/cathedral.b3e23d94.webp";